// extracted by mini-css-extract-plugin
module.exports = {"section":"index_section_332zh"};